module.exports = __webpack_public_path__ + "img/coo_invoice.ec9cd9e1.png";